import { SET_REVIEWS } from './types';

const setReviews = (payload) => ({
	type: SET_REVIEWS,
	payload
});

export default setReviews;
